import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';
let config = new SvgFactoryConfig();
config.iconName = "close-x";
config.viewBox="0 0 24 24"
config.shape = `
<path fill="var(--fill)" stroke="var(--stroke)" stroke-width="var(--stroke-width)" d="M3,3 L21,21 M3,21 L21,3"></path>
`;

let CloseXSVG = new SvgFactory(config);

export default CloseXSVG;